import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {TableService} from "./pager";
import {ActivatedRoute, Router} from "@angular/router";
import {WebService} from "../services/web/web.service";
import {SpinnerService} from "../services/spinner/spinner.service";
import {ToastService} from "../services/notification/toast.service";
import {MatTableDataSource} from "@angular/material/table";
import {HistoricFilter} from "./historic.filter";
import {SecurityService} from "../services/security.service";
import {UserPermissionsService} from "../services/user-permissions.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
    selector: 'app-historic-report',
    templateUrl: './historic-report.component.html',
    styleUrls: ['./historic-report.component.scss'],
    standalone: false
})
export class HistoricReportComponent implements OnInit {
  // PARA MANEJO DE PANEL DE BUSQUEDA
  isOpenSearchPanel = false;
  filter = new HistoricFilter(this.tableService.filter);

  services: any[] = [];

  datesFrom: any[] = [
    { "description": "ultimos 7 dias", "value": 1 },
    { "description": "ultimos 30 dias", "value": 2 },
    { "description": "Mes actual", "value": 3 },
    { "description": "Año actual", "value": 4 },
    { "description": "Rango personalizado", "value": 5 }
  ];
  invoiceStatus: any[] = [];

  // PARA MANEJO DE TABLAS
  @ViewChild(MatPaginator) paginator: MatPaginator | undefined;
  @ViewChild(MatSort) sort: MatSort | undefined;
  displayedColumns: string[] = ['service', 'plan', 'nameClient', 'emailClient', 'transaction', 'date', 'status', 'amount', 'lastDigits', 'motive'];
  dataSource: any;

    constructor(
        private securityService: SecurityService,
        public tableService: TableService<any>,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private cdr: ChangeDetectorRef,
        private webService: WebService,
        private spinner: SpinnerService,
        private toast: ToastService,
        private userPermissionsService: UserPermissionsService,
        private translate: TranslateService
    ) {
        this.tableService = new TableService;
    }

    ngOnInit(): void {
        this.isOpenSearchPanel = true;
        this.loadStatuses();
        this.list();
    }

    /**
     * Función auxiliar para parsear una cadena con formato "YYYY-MM-DD" en un objeto Date (hora local)
     */
    private parseDateString(dateStr: string): Date {
        const [year, month, day] = dateStr.split('-').map(Number);
        return new Date(year, month - 1, day); // El mes es 0-indexado.
    }

    private formatDateForRequest(value: Date | string): string {
        const date = typeof value === 'string'
            ? this.parseDateString(value)
            : value;

        return date.getFullYear() + '-' +
            String(date.getMonth() + 1).padStart(2, '0') + '-' +
            String(date.getDate()).padStart(2, '0');
    }

    private buildRequestFilter(): HistoricFilter | null {
        const requestFilter = new HistoricFilter(this.filter);

        if (requestFilter.dateSearchType && requestFilter.dateSearchType != 5) {
            const today = new Date();
            requestFilter.dateUntil = this.formatDateForRequest(today);

            if (requestFilter.dateSearchType == 1) {
                const sevenDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
                requestFilter.dateFrom = this.formatDateForRequest(sevenDaysAgo);
            } else if (requestFilter.dateSearchType == 2) {
                const thirtyDaysAgo = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 30);
                requestFilter.dateFrom = this.formatDateForRequest(thirtyDaysAgo);
            } else if (requestFilter.dateSearchType == 3) {
                const firstDayOfCurrentMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                requestFilter.dateFrom = this.formatDateForRequest(firstDayOfCurrentMonth);
            } else if (requestFilter.dateSearchType == 4) {
                const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
                requestFilter.dateFrom = this.formatDateForRequest(firstDayOfYear);
            }
        } else if (requestFilter.dateSearchType == 5) {
            if (!this.filter.dateFrom || this.filter.dateFrom === '' || !this.filter.dateUntil || this.filter.dateUntil === '') {
                this.toast.showError("Debe seleccionar un rango de fechas valido");
                return null;
            }

            const fromDate: Date = (typeof this.filter.dateFrom === 'string')
                ? this.parseDateString(this.filter.dateFrom)
                : (this.filter.dateFrom as unknown as Date);
            const untilDate: Date = (typeof this.filter.dateUntil === 'string')
                ? this.parseDateString(this.filter.dateUntil)
                : (this.filter.dateUntil as unknown as Date);

            if (fromDate > untilDate) {
                this.toast.showError("La fecha final debe ser mayor o igual que la fecha inicial");
                return null;
            }

            requestFilter.dateFrom = this.formatDateForRequest(fromDate);
            requestFilter.dateUntil = this.formatDateForRequest(untilDate);
        }

        return requestFilter;
    }

    list(event?: PageEvent) {
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning("No tienes permisos para consultar historial de transacciones.");
            this.dataSource = [];
            return;
        }

        this.spinner.open();
        if (
            this.filter.name_customer === undefined &&
            this.filter.email_customer === undefined &&
            this.filter.dateSearchType === undefined &&
            this.filter.id === undefined &&
            this.filter.minimum === undefined &&
            this.filter.maximum === undefined &&
            this.filter.status === undefined
        ) {
            this.spinner.close();
            this.toast.showInfo("Por favor seleccione un criterio de busqueda");
            return;
        }
        const requestFilter = this.buildRequestFilter();
        if (!requestFilter) {
            this.spinner.close();
            return;
        }


        let httpParams = this.webService.buildRequestParams(this.tableService.sort, "m", {
            pageIndex: event ? event.pageIndex : this.tableService.pager.pageIndex,
            pageSize: event ? event.pageSize : this.tableService.pager.pageSize
        });

        httpParams = requestFilter.getHttpParams(httpParams);

        if (this.securityService.getTokenPartner() == null || this.securityService.getTokenPartner() == undefined) {
            this.spinner.close();
            return this.toast.showInfo("NO se puede cargar reporte de clientes porque NO posees datos de tu compañía, por favor crea una suscripcion para poder cargar tus datos en nuestro sistema.");
        }

        this.webService.get(
            this.webService.HOST + "/partner/" + this.securityService.getTokenPartner() + "/invoices/list",
            httpParams
        ).subscribe(response => {
            if (response['result'].length === 0) {
                this.toast.showWarning("No existen resultados para mostrar");
            }

            // Procesar cada registro para establecer el valor por defecto en el campo motive cuando es null
            if (response['result'] && response['result'].length > 0) {
                response['result'].forEach(record => {
                    if (record.motive === null || record.motive === undefined) {
                        record.motive = "No aplicaba envío a banco";
                    }
                });
            }

            this.dataSource = new MatTableDataSource<any>(response['result']);
            this.tableService.pager = response['pager'];
            this.tableService.selection.clear();
            this.spinner.close();
        }, (err) => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }

    search() {
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning("No tienes permisos para consultar historial de transacciones.");
            return;
        }

        this.tableService.filter = new HistoricFilter(this.filter);
        this.router.navigate([], {
            queryParams: {
                name_customer: this.filter.name_customer
            }
        });
        this.list();
    }

    download() {
        if (!this.canViewInvoicesReport()) {
            this.toast.showWarning("No tienes permisos para descargar historial de transacciones.");
            return;
        }

        this.spinner.open();
        if (
            this.filter.name_customer === undefined &&
            this.filter.email_customer === undefined &&
            this.filter.dateSearchType === undefined &&
            this.filter.id === undefined &&
            this.filter.minimum === undefined &&
            this.filter.maximum === undefined &&
            this.filter.status === undefined
        ) {
            this.spinner.close();
            this.toast.showInfo("Por favor seleccione un criterio de busqueda");
            return;
        }

        const requestFilter = this.buildRequestFilter();
        if (!requestFilter) {
            this.spinner.close();
            return;
        }


        let httpParams = this.webService.buildRequestParams(this.tableService.sort, "m", {
            pageIndex: -1,
            pageSize: -1
        });

        httpParams = requestFilter.getHttpParams(httpParams);

        if (this.securityService.getTokenPartner() == null || this.securityService.getTokenPartner() == undefined) {
            this.spinner.close();
            return this.toast.showInfo("NO se puede cargar reporte de clientes porque NO posees datos de tu compañía, por favor crea una suscripcion para poder cargar tus datos en nuestro sistema.");
        }

        this.webService.get(
            this.webService.HOST + "/partner/" + this.securityService.getTokenPartner() + "/invoices/list",
            httpParams
        ).subscribe(response => {
            if (response['result'].length === 0) {
                this.toast.showWarning("No existen resultados para descargar");
                this.spinner.close();
                return;
            }
            // Convertir el resultado a CSV y descargarlo
            this.convertToCSVAndDownload(response['result']);
            this.spinner.close();
        }, (err) => {
            this.spinner.close();
            this.toast.showError(err);
        });
    }

    /**
     * Convierte un array de objetos a formato CSV y lo descarga
     * @param data Array de objetos a convertir
     */
    private convertToCSVAndDownload(data: any[]): void {
        // Verificar si hay datos
        if (!data || !data.length) {
            this.toast.showWarning("No hay datos para exportar");
            return;
        }

        try {
            // El código del cliente debe ocupar siempre una columna propia, aunque el
            // backend todavía no lo incluya en la respuesta.
            const headers = Object.keys(data[0]).filter(header => header !== 'codeCustomer');
            const customerColumnIndex = headers.indexOf('lastNameClient') >= 0
                ? headers.indexOf('lastNameClient')
                : headers.indexOf('nameClient');
            headers.splice(customerColumnIndex + 1, 0, 'codeCustomer');

            // Mapeo de nombres de cabeceras originales a nombres amigables en español
            const headerMapping = {
                'motive': 'Respuesta del banco',
                'service': 'Servicio',
                'plan': 'Plan',
                'nameClient': 'Cliente',
                'codeCustomer': this.translate.instant('historicReport.table.columns.customerCode'),
                'emailClient': 'Email',
                'transaction': 'ID',
                'date': 'Fecha',
                'status': 'Estatus',
                'amount': 'Monto',
                'lastDigits': 'Últimos 4 Dígitos'
                // Agregar más mapeos según sea necesario
            };

            // Crear la línea de cabeceras con los nombres amigables
            const friendlyHeaders = headers.map(header =>
                headerMapping[header] || header // Usa el nombre amigable si existe, o el original si no
            );
            let csvContent = friendlyHeaders.join(',') + '\n';

            // Agregar los datos
            data.forEach(item => {
                const row = headers.map(header => {
                    if (header === 'codeCustomer') {
                        const customerCode = item[header] === null || item[header] === undefined
                            ? ''
                            : String(item[header]);
                        // Excel interpreta la expresión como texto y conserva los ceros iniciales.
                        return customerCode ? `"=""${customerCode.replace(/"/g, '""')}"""` : '';
                    }
                    // Caso especial para el campo "motive" cuando es null
                    if (header === 'motive' && (item[header] === null || item[header] === undefined)) {
                        return '"No aplicaba envío a banco"';
                    }
                    // Manejar valores nulos o indefinidos
                    const cell = item[header] === null || item[header] === undefined ? '' : item[header];
                    // Escapar comillas y encerrar en comillas si contiene comas, comillas o saltos de línea
                    const cellStr = String(cell);
                    if (cellStr.includes(',') || cellStr.includes('"') || cellStr.includes('\n')) {
                        return `"${cellStr.replace(/"/g, '""')}"`;
                    }
                    return cellStr;
                });
                csvContent += row.join(',') + '\n';
            });

            // Crear un blob con el contenido CSV
            const blob = new Blob(['\uFEFF' + csvContent], {type: 'text/csv;charset=utf-8;'});

            // Crear URL para el blob
            const url = window.URL.createObjectURL(blob);

            // Crear un elemento <a> para descargar
            const link = document.createElement('a');
            link.setAttribute('href', url);

            // Generar nombre del archivo con fecha actual
            const date = new Date();
            const formattedDate = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
            link.setAttribute('download', `reporte_historico_${formattedDate}.csv`);

            // Ocultar el enlace y simular el clic para descargar
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.toast.showSuccess("Reporte descargado exitosamente");
        } catch (error) {
            console.error('Error al generar CSV:', error);
            this.toast.showError("Error al generar el archivo CSV");
        }
    }

    openSearchPanel(value: boolean) {
        this.isOpenSearchPanel = value;
        this.filter = new HistoricFilter(this.filter);
    }

    reset() {
        this.filter = new HistoricFilter();
        this.tableService.filter = null;
        this.dataSource = [];
        delete this.filter.name_customer;
        // this.isOpenSearchPanel = false;
        this.search();
    }

    canViewInvoicesReport(): boolean {
        return this.userPermissionsService.hasPermission("onboarding.history.getTransactions");
    }

    goBack() {
        this.router.navigate(["/my-portals"]);
    }

    private loadStatuses() {
        this.spinner.open();
        this.webService.get(`${this.webService.HOST}/statuses`)
            .subscribe(
                (response: any) => {
                    this.invoiceStatus = response.result;
                    // Ordenar alfabéticamente por description
                    this.invoiceStatus.sort((a: any, b: any) => {
                        if (a.description < b.description) {
                            return -1;
                        }
                        if (a.description > b.description) {
                            return 1;
                        }
                        return 0;
                    });
                    this.spinner.close();
                },
                (error) => {
                    this.spinner.close();
                    this.toast.showError(error);
                }
            );
    }
}
